import { render, staticRenderFns } from "./LowQuantityAlert.vue?vue&type=template&id=a140dbfe"
import script from "./LowQuantityAlert.vue?vue&type=script&lang=js"
export * from "./LowQuantityAlert.vue?vue&type=script&lang=js"
import style0 from "./LowQuantityAlert.vue?vue&type=style&index=0&id=a140dbfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports